// Powerful Words page — the GP taxonomy as nested headings.
//
// One main section is open at a time; within it, one subheading is open at a
// time. Opening a heading brings it to the top of the screen.

function setOpen(button, open) {
  button.setAttribute('aria-expanded', open ? 'true' : 'false');
  document.getElementById(button.getAttribute('aria-controls')).hidden = !open;
}

function toggleHeading(button, scope, selector) {
  const wasOpen = button.getAttribute('aria-expanded') === 'true';
  scope.querySelectorAll(selector).forEach(function(b) { setOpen(b, false); });
  if (wasOpen) return;

  setOpen(button, true);
  button.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function initPowerfulWords() {
  const taxonomy = document.getElementById('tax');
  if (!taxonomy || taxonomy.dataset.bound) return;
  taxonomy.dataset.bound = 'true';

  taxonomy.addEventListener('click', function(event) {
    const main = event.target.closest('.pw-main-h');
    const sub = event.target.closest('.pw-sub-h');

    if (main) {
      toggleHeading(main, taxonomy, '.pw-main-h');
      // Switching main section folds every subheading away.
      taxonomy.querySelectorAll('.pw-sub-h').forEach(function(b) { setOpen(b, false); });
    } else if (sub) {
      toggleHeading(sub, sub.closest('.pw-subs'), '.pw-sub-h');
    }
  });
}

document.addEventListener('turbo:load', initPowerfulWords);
document.addEventListener('DOMContentLoaded', initPowerfulWords);
